import { render, staticRenderFns } from "./click-to-edit-confirm.vue?vue&type=template&id=4465d5f6&"
import script from "./click-to-edit-confirm.vue?vue&type=script&lang=js&"
export * from "./click-to-edit-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports